'use strict';

const { createReducerStore } = require('fluxible-reducer-store');
const appFactory = require('./appFactory.es');

const RegionalInfoStore = require('../stores/RegionalInfoStore.es');
const UserStore = createReducerStore(require('../stores/UserStore.es'));
const CartStore = require('../stores/CartStore.es');
const PortfolioStore = require('../stores/PortfolioStore');
const ContactDealerStore = createReducerStore(require('../../newPdp/stores/ContactDealerStore.es'));

const StickyAlertTopStore = require('../../components/StickyAlert/StickyAlertTop/StickyAlertTop-store');
const CalloutStore = require('../../components/Callout/CalloutStore');

/**
 * Setups Fluxible App for use on the server and client.
 *
 * Registers the stores needed to communicate with the global nav bar and
 * registers RegionalInfoStore needed to communicate with global user auth modal,
 *
 * @param {Array} [stores=[]] - Array of stores to register onto App
 * @param {Object} [options={}]
 * @returns {Object} - Fluxible App
 */
function appSetup(stores = [], options) {
    const App = appFactory(stores);

    if (options.connectCartStore) {
        App.registerStore(CartStore);
    }

    App.registerStore(RegionalInfoStore);
    App.registerStore(UserStore);
    App.registerStore(PortfolioStore);
    App.registerStore(ContactDealerStore);

    App.registerStore(StickyAlertTopStore);

    App.registerStore(CalloutStore);

    return App;
}

module.exports = appSetup;



// WEBPACK FOOTER //
// ./assets/js/global/reactHelpers/appSetup.es.js